import { Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[numMaxlength]' })
export class NummaxLengthDirective {
    constructor(el: ElementRef) {
        const test = el.nativeElement;
    }
}
